import React from 'react';

import CommonModal from '../common-modal/CommonModal';

import scss from './ImageModal.module.scss';

function ImageModal({ isOpen, onClose, imageUrl, ActionButtons }) {
  return (
    <CommonModal isOpen={isOpen} onClose={onClose} isAnimated>
      <div className={scss.wrapper}>
        <img src={imageUrl} alt='background' className={scss.background} />
        <img src={imageUrl} alt='generated-image' className={scss.generatedImage} />

        {ActionButtons && <div className={scss.actions}>{ActionButtons}</div>}
      </div>
    </CommonModal>
  );
}

export default ImageModal;
